import Debtor from '@/components/services/AcceptanceDeposit/Debtor/Manual/index.vue';
import Creditors from '@/components/services/AcceptanceDeposit/Creditors/index.vue';
import DepositDetails from '@/components/services/AcceptanceDeposit/DepositDetails.vue';
import DebtorBankDetails from '@/components/services/AcceptanceDeposit/DebtorBankDetails.vue';
import ApplicantBankDetails from '@/components/services/AcceptanceDeposit/ApplicantBankDetails.vue';
import StepDocuments from '@/components/services/common/StepDocuments.vue';

import SelectDebtorFillType from '@/components/services/AcceptanceDeposit/SelectDebtorFillType.vue';
import DebtorFillType from '@/components/services/AcceptanceDeposit/DebtorFillType.vue';

import { isMrpaEnable } from '@/app.config';
import { StatementType } from '@/constants';

const commonSteps: unknown[] = [
  Creditors,
  DepositDetails,
  DebtorBankDetails,
  ApplicantBankDetails,
  StepDocuments,
];
const steps: unknown[] = [Debtor, ...commonSteps];

const mrpaSteps: unknown[] = [
  SelectDebtorFillType,
  DebtorFillType,
  ...commonSteps,
];

export const acceptanceDepositSteps: unknown[] = isMrpaEnable(
  StatementType.ACCEPTANCE_DEPOSIT
)
  ? mrpaSteps
  : steps;
